import { createContext } from 'react';

export type CheckListItemValue = string | number;
export type CheckListValue = CheckListItemValue[] | CheckListItemValue | undefined;

export const CheckListContext = createContext<{
  checkedValues: CheckListItemValue[];
  onChange: (value: CheckListItemValue, defaultChange?: boolean) => void;
  checkedClassPrefix: string;
  stopPropagation?: boolean;
} | null>(null);
